export const TEMP_SELECTED_LIFESTYLE_LAST_ID = 999999999;

export enum LifestylesSetsPermissions {
  READ_LIFESTYLES_SET_DOWNLOAD_BUTTON = 'read_lifestyles_set_download_button',
  READ_LIFESTYLES_SET_DOWNLOAD_SEPARATELY_BUTTON = 'read_lifestyles_set_download_separately_button',
  READ_LIFESTYLES_SET_CLEAR_BUTTON = 'read_lifestyles_set_clear_button'
}
